import { defineStore, acceptHMRUpdate } from "pinia";
import Api from "../utils/api";
import { convertImageToBase64, deepMerge, showToast } from "../utils/helper";
import { pdfBase64 } from "pkg-pdf-generator";

export const usePdfLayoutStore = defineStore("pdf_layouts_store", {
  persist: true,
  state: () => ({}),
  actions: {
    async getPdfLayout(config) {
      let _res = await Api.PdfLayout.getPdfLayout(config);
      if (_res.error) throw _res.error;
      if (_res.data.length < 1) throw new Error("No layout found");
      return _res.data[0];
    },

    async getAddOnPdfLayouts(config) {
      let _res = await Api.PdfLayout.getAddOnPdfLayouts(config);
      if (_res.error) throw _res.error;
      return _res.data;
    },

    async generatePDFBase64(formData, layoutData, addOnLayout) {
      try {
        let convertedAttachments = [];
        if (formData.attachments) {
          if (typeof formData.attachments === "string") {
            formData.attachments = formData.attachments
              ? JSON.parse(formData.attachments)
              : [];
          }

          if (formData.attachments && formData.attachments.length > 0) {
            for (let i = 0; i < formData.attachments.length; i++) {
              const item = formData.attachments[i];
              try {
                const imgBase64 = await convertImageToBase64(item.url);
                if (imgBase64 !== null) {
                  convertedAttachments.push({
                    value: imgBase64
                  });
                }
              } catch (error) {
                console.warn(
                  `Skipping attachment at '${item.url}' due to error:`,
                  error
                );
              }
            }
          }
        }
        if (
          typeof addOnLayout === "object" &&
          addOnLayout !== null &&
          Object.keys(addOnLayout).length > 0
        ) {
          if (addOnLayout.isPartial) {
            // TODO: Implement partial layout merging
          } else {
            const addOnPDF = await this.generatePDFBase64(
              formData,
              addOnLayout.content
            );
            formData = deepMerge(formData, {
              appendPDFData: {
                value: addOnPDF,
                name: "addOnPDF",
                type: "application/pdf"
              }
            });
          }
        }
        // after converting attachments to base64, add the attachments to the form data
        formData.attachments = convertedAttachments;
        const base64content = await pdfBase64(layoutData, formData);
        return base64content;
      } catch (error) {
        showToast("Error", `PDF Download Failed : ${error}`, "error");
        throw error;
      }
    }
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePdfLayoutStore, import.meta.hot));
}
